import React, { useRef } from "react";
import { Dropdown } from "bootstrap";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useAuthHeader } from "../../../auth/AuthService";
import { useTranslation } from "react-i18next";
import { createUser, deleteUser, retrieveUser, retrieveUserCompany, updateUser } from "../../../Services/Admin/UserApiService";
import { useEffect } from "react";
import { retrievFirm, retrievFirmStock } from "../../../Services/Admin/FirmApiService";
import { retrievGroup } from "../../../Services/Admin/GroupApiService";
import { Badge } from 'primereact/badge';
import { classNames } from "primereact/utils";
import { Toast } from "primereact/toast";


export default function UserDataTable({groupId, firmId}) {
    const {t, i18n} = useTranslation();
    const authHeader = useAuthHeader();
    const [users, setUsers] = useState(null);
    const [userDialog, setUserDialog] = useState(false);
    const [showUserDialog, setShowUserDialog] = useState(false);
    const [deleteUserDialog, setDeleteUserDialog] = useState(false);
    const [user, setUser] = useState([]);
    const [edit, setEdit] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);
    const [filter, setFilter] = useState({'perPage': 10, 'page': 0 });
    const [firstPage, setFirstPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [firms, setFirms] = useState([]);
    const [firmCreate, setFirmCreate] = useState([]);
    const [groups, setGroups] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [userTypeCreation, setUserTypeCreation] = useState('N');
    const [stocks, setStocks] = useState([]);

    const getUser = async () => {
        setLoading(true);
        await retrieveUser(authHeader(), {...filter, groupId: groupId, firm: firmId})
        .then((response) => {
            setUsers(response?.data?.data);
            setLoading(false);
        })
        .catch((error) => console.log(error));
    }

    const branches = [
        {value: '00', name: 'Head Office'},
        {value: '01', name: 'Branch 01'},
        {value: '02', name: 'Branch 02'},
        {value: '03', name: 'Branch 03'},
        {value: '04', name: 'Branch 04'},
        {value: '05', name: 'Branch 05'},
        {value: '06', name: 'Branch 06'},
        {value: '07', name: 'Branch 07'},
        {value: '08', name: 'Branch 08'},
        {value: '09', name: 'Branch 09'},
    ]

    const userTypes = [
        {value: 'CSX', name: 'CSX'},
        {value: 'Member', name: 'Member'},
        {value: 'Participant', name: 'Participant'},
        {value: 'Issuer', name: 'Issuer'},
        {value: 'Institutional Investor', name: 'Institutional Investor'},
        {value: 'Financial Institution', name: 'Financial Institution'},
        {value: 'Data Distributor', name: 'Data Distributor'},
        {value: 'Regulator', name: 'Regulator'},
        {value: 'Other', name: 'Other'},
    ]

    const screenType = [
        {value: 'All Stocks', name: 'All Stocks'},
        {value: 'One Stock', name: 'One Stock'}
    ]

    useEffect(() => {
        getUser()
        // getFirm()
        // getGroup()
        // getCompany()
        // getStock()
    }, []);

    const getFirm = async () => {
        await retrievFirm(authHeader())
        .then((response) => {
            let firms = response?.data?.data?.map(v => {
                return {'name': v.abbr, 'value': v.id}
            });
            setFirmCreate(firms);
            firms.unshift ({'name': 'All Firms', 'value': 0})
            setFirms(firms);
        })
        .catch((error) => console.log(error));
    }

    const getGroup = async () => {
        await retrievGroup(authHeader())
        .then((response) => {
            let groups = response?.data?.data?.map(v => {
                return {'name': v.name, value: v.id}
            });
            setGroups(groups);
        })
        .catch((error) => console.log(error));
    }

    const getCompany = async () => {
        await retrieveUserCompany(authHeader())
        .then((response) => {
            let companies = response?.data?.data?.map(v => {
                return {'name': v, 'value': v}
            });
            companies.push({'name': 'New Company', 'value': 'New Company'})
            setCompanies(companies);
        })
        .catch((error) => console.log(error));
    }

    const getStock = async () => {
        await retrievFirmStock(authHeader())
        .then((response) => {
            let data = response.data.data;
            let arr = [];
            data.map(v => {
                arr.push({name: v[1], value: v[0]});
            });
            setStocks(arr);
        })
        .catch((error) => console.log(error));
    }

    const onPageChange = (page) => {
        setFirstPage(page.first);
        setFilter({...filter, 'perPage': page.rows, 'page': page.page});
    }

    const onSort = (sort) => {
        setFilter({...filter, 'sortField': sort.sortField, 'sortOrder': sort.sortOrder});
    }

    const hideDialog = () => {
        setSubmitted(false);
        setUserDialog(false);
    };

    const hideDeleteUserDialog = () => {
        setDeleteUserDialog(false);
    };

    const editUser = (user) => {
        setEdit(true);
        reset({
            id: user.id,
            username: user.username,
            investor: user.investor,
            name: user.name,
            email: user.email,
            phone: user.phone,
            password: '',
            confirmPassword: '',
            status: user.activated,
            expired: user.expired,
            group: user.group_id+'',
            firm: user.firmId,
            dd_address: user.dd_address,
            dd_company: user.dd_company,
            dd_branch: user.dd_branch,
            dd_user_type: user.dd_user_type,
        });
        setUser({ ...user });
        setUserDialog(true);
    };

    const confirmDeleteUser = (user) => {
        setUser(user);
        setDeleteUserDialog(true);
    };

    const statusBodyTemplate = (rowData) => {
        let status = '';
        if (rowData.activated === 1) {
            status = <Badge value="Yes" severity="success"></Badge>
        } else if (rowData.activated === 0) {
            status = <Badge value="No" severity="danger"></Badge>
        } else if (rowData.activated === 2) {
            status = <Badge value="Blocked" severity="dark"></Badge>
        }
        return status;
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-eye" rounded outlined className="mr-2" style={{height:'2rem', width:'2rem'}} onClick={() => {setUser(rowData); setShowUserDialog(true)}} />
                {/* <Button icon="pi pi-pencil" rounded outlined className="mr-2" style={{height:'2rem', width:'2rem'}} onClick={() => editUser(rowData)} />
                <Button icon="pi pi-trash" rounded outlined severity="danger" style={{height:'2rem', width:'2rem'}} onClick={() => confirmDeleteUser(rowData)} /> */}
            </React.Fragment>
        );
    };

    const dataFormat = (date) => {
        return (date.getDate() < 10 ? "0" : "") + date.getDate() + '-' + t(date.toLocaleString('default', { month: 'short' })) + '-' + date.getFullYear()
    }

    const onDeleteUser = async () => {
        user.id && await deleteUser(authHeader(), user.id)
            .then((response) => {
                if (response.status === 200) {
                    getUser()
                    toast.current.show({ severity: 'info', detail: "User Deleted!", life: 3000 });
                } 
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', detail: "Something went wrong!", life: 3000 });
            });
        setDeleteUserDialog(false);
    };

    const deleteUserDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteUserDialog} />
            <Button label="Yes" icon="pi pi-check" severity="danger" onClick={onDeleteUser} />
        </React.Fragment>
    );

    const defaultValues = {
        id: undefined,
        username: '',
        investor: '',
        name: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
        status: '',
        expired: '',
        group: '',
        firm: '',
        dd_address: undefined,
        dd_company: undefined,
        dd_branch: undefined,
        dd_user_type: undefined,
    };

    const {
        control,
        formState: { errors },
        handleSubmit,
        watch,
        reset,
        setError
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error pt-1 pb-3 text-left">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const statuses = [
        { name: 'Deactivated', value: 0},
        { name: 'Activated', value: 1},
        { name: 'Blocked', value: 2},
    ]

    Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }

    const expiredDateFormat = (date) => {
        return date.getFullYear() + '-' +((date.getMonth()+1 < 10 ? "0" : "") + (date.getMonth()+1)) + '-' +( (date.getDate() < 10 ? "0" : "") + date.getDate()) + " 00:00:00";
    }

    const expireds = [
        { name: '7Days', value: expiredDateFormat(new Date().addDays(7))},
        { name: '1Month', value: expiredDateFormat(new Date().addDays(30))},
        { name: '2Months', value: expiredDateFormat(new Date().addDays(60))},
        { name: '3Months', value: expiredDateFormat(new Date().addDays(90))},
        { name: '6Months', value: expiredDateFormat(new Date().addDays(182))},
        { name: '1Year', value: expiredDateFormat(new Date().addDays(365))},
        { name: 'Forever', value: '9999-12-31 00:00:00'},
    ]

    const getCompanyCode = (company) => {
        let code = null;
        if (company.substring(0, 1) != '(') 
            return code;

        if (company.substring(4, 5) == ')') {
            code = company.substring(1, 4);
        } 
        else if (company.substring(5, 6) == ')') {
            code = company.substring(1, 5);
        }

        return code;
    }

    const onSubmit = async (data) => {
        let fData = {
            ...data,
            ddYn: userTypeCreation,
            name: userTypeCreation === 'N' ? data?.name : data?.username
        }
        if (edit && data.id) {
            await updateUser(authHeader(), fData, data.id)
            .then((response) => {
                if (response.status === 200) {
                    hideDialog();
                    getUser()
                    toast.current.show({ severity: 'info', detail: "User Updated!", life: 3000 });
                    reset(defaultValues)
                } 
            })
            .catch((error) => {
                if (error?.response?.status === 400) {
                    setError('username', {
                        type: "server",
                        message: error?.response?.data,
                    });
                }
            });
        } else {
            await createUser(authHeader(), fData)
            .then((response) => {
                if (response.status === 200) {
                    hideDialog();
                    getUser()
                    toast.current.show({ severity: 'info', detail: "User Created!", life: 3000 });
                    reset(defaultValues)
                } 
            })
            .catch((error) => {
                if (error?.response?.status === 400) {
                    setError('username', {
                        type: "server",
                        message: error?.response?.data,
                    });
                }
            });
        }
        
    };
    
    return (
        <>
        <Toast ref={toast} />
            <DataTable ref={dt} value={users?.content}
                dataKey="id"  paginator rowsPerPageOptions={[5, 10, 25, 50]}
                lazy
                first={firstPage}
                rows={filter.perPage}
                totalRecords={users?.totalElements}
                onPage={onPageChange}
                onSort={onSort}
                sortField={filter.sortField}
                sortOrder={filter.sortOrder}
                loading={loading}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
                className="text-sm"
            >
                <Column field="id" header={t("ID")} sortable></Column>
                <Column field="username" header={t("Username")} sortable ></Column>
                <Column field="name" header={t("Name")} sortable ></Column>
                <Column field="email" header={t("Email")} sortable ></Column>
                <Column field="phone" header={t("Phone")} sortable ></Column>
                <Column field="role" header={t("Role")} sortable ></Column>
                <Column field="activated" header={t("Activation")} body={statusBodyTemplate} sortable ></Column>
                <Column field="created" header={t("Created")} body={(e) => e.created && dataFormat(new Date(e.created))} sortable ></Column>
                <Column field="modified" header={t("Modified")} body={(e) => e.modified && dataFormat(new Date(e.modified))} sortable></Column>
                <Column field="expired" header={t("Expired")} body={(e) => e.expired && dataFormat(new Date(e.expired))} sortable ></Column>
                <Column header={t("Actions")} body={actionBodyTemplate} style={{minWidth: '9rem'}} ></Column>
            </DataTable>

            <Dialog visible={userDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={edit ? 'Edit User' : "Add User"} modal className="p-fluid" onHide={hideDialog}>
                <form onSubmit={handleSubmit(onSubmit)} className="pt-2 flex flex-column w-full">
                    <div className='grid'>
                        <Controller
                            name="id"
                            control={control}
                            render={({ field }) => (
                                <input type="hidden" value={field.value}></input>
                            )}
                        />
                        <Controller
                            name="username"
                            control={control}
                            rules={{ 
                                required: 'Username is required.',
                                validate: (val) => {
                                    if (userTypeCreation === 'Y') {
                                        let code = getCompanyCode(watch('dd_company'))
                                        let codeFromUsername = val.substring(0, code.length);
                                        let branchFromUsername = val.substring(code.length, code.length + 2);
                                        let terminalFromUsername = val.substring(val.length-2);
                                        if (code != codeFromUsername || watch('dd_branch') != branchFromUsername || isNaN(terminalFromUsername)) {
                                            return "Username is invalid.";
                                        }
                                    }
                                } 
                            }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <InputText id="username" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor="username" className="bg-login-card z-5">Username</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />
                        {/* {userTypeCreation === 'Y' && <Controller
                            name="dd_company"
                            control={control}
                            rules={{ required: 'Company is required.'}}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Dropdown inputId="company" value={field.value} onChange={(e) => field.onChange(e.value)} options={companies} optionLabel="name" className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} />
                                        <label htmlFor="company">Company</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />} */}
                        {userTypeCreation === 'Y' && watch('dd_company') === 'New Company' && <Controller
                            name="new_company"
                            control={control}
                            rules={{ required: 'Company is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <InputText id="new_company" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor="new_company">New Company</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />}
                        {/* { userTypeCreation === 'Y' && <Controller
                            name="dd_branch"
                            control={control}
                            rules={{ required: 'Head Office/Branch is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Dropdown inputId="branch" value={field.value} onChange={(e) => field.onChange(e.value)} options={branches} optionLabel="name" className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} />
                                        <label htmlFor="branch">Head Office/Branch</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />} */}
                        { userTypeCreation === 'Y' && <Controller
                            name="dd_address"
                            control={control}
                            rules={{ required: 'Address is required.' }}
                            render={({ field, fieldState }) => (
                                <div  className="col-6">
                                    <span className="p-float-label w-full">
                                        <InputText id="address" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor="address" className="bg-login-card z-5">Address</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />}
                        { userTypeCreation === 'N' && <Controller
                            name="investor"
                            control={control}
                            rules={{ required: 'Investor ID is required.' }}
                            render={({ field, fieldState }) => (
                                <div  className="col-6">
                                    <span className="p-float-label w-full">
                                        <InputText id="investor" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor="investor" className="bg-login-card z-5">Investor's ID</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />}
                        { userTypeCreation === 'N' && <Controller
                            name="name"
                            control={control}
                            rules={{ required: 'Name is required.' }}
                            render={({ field, fieldState }) => (
                                <div  className="col-6">
                                    <span className="p-float-label w-full">
                                        <InputText id="name" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor="name" className="bg-login-card z-5">Name</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />}
                        <Controller
                            name="email"
                            control={control}
                            render={({ field, fieldState }) => (
                                <div  className="col-6">
                                    <span className="p-float-label w-full">
                                        <InputText id="email" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor="email" className="bg-login-card z-5">Email</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />
                        <Controller
                            name="phone"
                            control={control}
                            rules={{ required: 'Phone is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <InputText id="phone" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor="phone" className="bg-login-card z-5">Phone</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />
                        {/* { userTypeCreation === 'Y' && <Controller
                            name="dd_user_type"
                            control={control}
                            rules={{ required: 'User Type is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Dropdown inputId="user_type" value={field.value} onChange={(e) => field.onChange(e.value)} options={userTypes} optionLabel="name" className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} />
                                        <label htmlFor="user_type">User Type</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />} */}
                        {/* { userTypeCreation === 'Y' && <Controller
                            name="screen_type"
                            control={control}
                            rules={{ required: 'Screen Type is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Dropdown inputId="screen_type" value={field.value} onChange={(e) => field.onChange(e.value)} options={screenType} optionLabel="name" className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} />
                                        <label htmlFor="screen_type">Screen Type</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />} */}
                        {/* { userTypeCreation === 'Y' && watch('screen_type') !== 'All Stocks' && <Controller
                            name="stock_name"
                            control={control}
                            rules={{ required: 'Stock Name is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Dropdown inputId="stock_name" value={field.value} onChange={(e) => field.onChange(e.value)} options={stocks} optionLabel="name" className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} />
                                        <label htmlFor="stock_name">Stock Name</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />} */}
                        <Controller
                            name="password"
                            control={control}
                            rules={{ 
                                validate: (val) => {
                                    if (!edit) {
                                        if (!val) {
                                            return 'Password is required.';
                                        }
                                        if (val.length < 8) {
                                            return "Minimum 8 characters long";
                                        }
                                    }
                                    
                                }
                            }}
                            render={({ field, fieldState }) => (
                                <div  className="col-6">
                                    <span className="p-float-label w-full">
                                        <Password id="password" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor="password" className="bg-login-card z-5">Password</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />
                        <Controller
                            name="confirmPassword"
                            control={control}
                            rules={{
                                validate: (val) => {
                                    if (!edit) {
                                        if (!val) {
                                            return 'Confirm password is required.';
                                        }
                                        if (watch('password') != val) {
                                            return "Confirm password do not match";
                                        }
                                    }
                                }
                            }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Password id="confirmPassword" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                        <label htmlFor="confirmPassword" className="bg-login-card z-5">Confirm password</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />
                        {/* <Controller
                            name="status"
                            control={control}
                            rules={{ required: 'Status is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Dropdown inputId="status" value={field.value} onChange={(e) => field.onChange(e.value)} options={statuses} optionLabel="name" className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} />
                                        <label htmlFor="status">Status</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        /> */}
                        {/* <Controller
                            name="expired"
                            control={control}
                            rules={{ required: 'Expired is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Dropdown inputId="expired" value={field.value} onChange={(e) => field.onChange(e.value)} options={expireds} optionLabel="name" className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} />
                                        <label htmlFor="expired" className="bg-login-card z-5">Expired</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        /> */}
                        {/* { userTypeCreation === 'N' && <Controller
                            name="group"
                            control={control}
                            rules={{ required: 'Group is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Dropdown inputId="group" value={field.value} onChange={(e) => field.onChange(e.value)} options={groups} optionLabel="name" className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} />
                                        <label htmlFor="group" className="bg-login-card z-5">Group</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />} */}
                        { userTypeCreation === 'N' && <Controller
                            name="firm"
                            control={control}
                            rules={{ required: 'Firm is required.' }}
                            render={({ field, fieldState }) => (
                                <div className="col-6">
                                    <span className="p-float-label w-full">
                                        <Dropdown inputId="firm" value={field.value} onChange={(e) => field.onChange(e.value)} options={firmCreate} optionLabel="name" className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} />
                                        <label htmlFor="firm" className="bg-login-card z-5">Firm</label>
                                    </span>
                                    {getFormErrorMessage(field.name)}
                                </div>
                            )}
                        />}
                    </div>
                    <div className="flex justify-content-end">
                        <Button type="submit" label="Submit" className="w-4 p-3 text-xl" ></Button>
                    </div>
                </form>
            </Dialog>

            <Dialog visible={showUserDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="User Preview" modal className="p-fluid" onHide={() => setShowUserDialog(false)}>
                <div className="grid">
                    <div className="col-6">
                        <div className="flex flex-column gap-1 mb-3">
                            <span>ID</span>
                            <span className="font-bold">{user?.id}</span>
                        </div>
                        <div className="flex flex-column gap-1 mb-3">
                            <span>Username</span>
                            <span className="font-bold">{user?.username}</span>
                        </div>
                        <div className="flex flex-column gap-1 mb-3">
                            <span>Investor's ID</span>
                            <span className="font-bold">{user?.investor}</span>
                        </div>
                        <div className="flex flex-column gap-1 mb-3">
                            <span>Name</span>
                            <span className="font-bold">{user?.name}</span>
                        </div>
                        <div className="flex flex-column gap-1 mb-3">
                            <span>E-mail</span>
                            <span className="font-bold">{user?.email}</span>
                        </div>
                        <div className="flex flex-column gap-1 mb-3">
                            <span>Tel.</span>
                            <span className="font-bold">{user?.phone}</span>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="flex flex-column gap-1 mb-3">
                            <span>Activation</span>
                            <span className="font-bold">{statusBodyTemplate(user)}</span>
                        </div>
                        <div className="flex flex-column gap-1 mb-3">
                            <span>Role</span>
                            <span className="font-bold">{user?.role}</span>
                        </div>
                        <div className="flex flex-column gap-1 mb-3">
                            <span>Created</span>
                            <span className="font-bold">{user.created && dataFormat(new Date(user.created))}</span>
                        </div>
                        <div className="flex flex-column gap-1 mb-3">
                            <span>Last modification</span>
                            <span className="font-bold">{user.modified && dataFormat(new Date(user.modified))}</span>
                        </div>
                        <div className="flex flex-column gap-1 mb-3">
                            <span>Expired</span>
                            <span className="font-bold">{user.expired && dataFormat(new Date(user.expired))}</span>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={deleteUserDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Delete User" modal footer={deleteUserDialogFooter} onHide={hideDeleteUserDialog}>
                <div className="confirmation-content">
                    {user && (
                        <span>
                            Are you sure you want to delete <b>{user.username}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}